module.exports = __webpack_public_path__ + "media/images/icons/guruwari-0e87959b099fb756965e0eb52977e44a.png";